// Function to allow mocking of clientWidth calls
export const getClientWidth = (el) => el && el.getBoundingClientRect().width;
